module.exports = __webpack_public_path__ + "static/img/product01-6.d5b8b2e7.png";